import * as yup from 'yup'
import translation from 'i18next'

export const hoursReportInfoSchema = yup.object({
  research_time_minutes: yup
    .number()
    .typeError(translation.t('errors:validation.numberType'))
    .required(),
  travel_time_minutes: yup
    .number()
    .typeError(translation.t('errors:validation.numberType'))
    .required(),
  reporting_time_minutes: yup
    .number()
    .typeError(translation.t('errors:validation.numberType'))
    .required(),
  travel_distance_km: yup
    .number()
    .typeError(translation.t('errors:validation.numberType'))
    .required(),
})
